module.exports = __webpack_public_path__ + "img/logo-legisla.f10dfeac.svg";